/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Domain_Manager_Need_MoreInputs */

const en_domain_manager_need_more = /** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need more domains?`)
};

const es_domain_manager_need_more = /** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Necesitas más dominios?`)
};

const fr_domain_manager_need_more = /** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besoin de plus de domaines ?`)
};

const de_domain_manager_need_more = /** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brauchst du mehr Domains?`)
};

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const ja_domain_manager_need_more = en_domain_manager_need_more;

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const zh_domain_manager_need_more = en_domain_manager_need_more;

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const ar_domain_manager_need_more = en_domain_manager_need_more;

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const id_domain_manager_need_more = en_domain_manager_need_more;

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const it_domain_manager_need_more = en_domain_manager_need_more;

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const ru_domain_manager_need_more = en_domain_manager_need_more;

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const pt_domain_manager_need_more = en_domain_manager_need_more;

/** @type {(inputs: Domain_Manager_Need_MoreInputs) => LocalizedString} */
const ko_domain_manager_need_more = en_domain_manager_need_more;

/**
* | output |
* | --- |
* | "Need more domains?" |
*
* @param {Domain_Manager_Need_MoreInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const domain_manager_need_more = /** @type {((inputs?: Domain_Manager_Need_MoreInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Domain_Manager_Need_MoreInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_domain_manager_need_more(inputs)
	if (locale === "es") return es_domain_manager_need_more(inputs)
	if (locale === "fr") return fr_domain_manager_need_more(inputs)
	if (locale === "de") return de_domain_manager_need_more(inputs)
	if (locale === "ja") return ja_domain_manager_need_more(inputs)
	if (locale === "zh") return zh_domain_manager_need_more(inputs)
	if (locale === "ar") return ar_domain_manager_need_more(inputs)
	if (locale === "id") return id_domain_manager_need_more(inputs)
	if (locale === "it") return it_domain_manager_need_more(inputs)
	if (locale === "ru") return ru_domain_manager_need_more(inputs)
	if (locale === "pt") return pt_domain_manager_need_more(inputs)
	return ko_domain_manager_need_more(inputs)
});